import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMTextField from 'src/components/UI/atoms/formFields/ATMTextField/ATMTextField';
import { ExpenseCategoriesFormValues } from 'src/models/ExpenseCategories.model';

type Props = {
    formikProps: FormikProps<ExpenseCategoriesFormValues>;
    onClose: () => void;
    formType: "ADD" | "EDIT";
};

const ExpenseCategoriesForm = ({ formikProps, onClose, formType }: Props) => {
    const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

    return (
        <div className='p-4 flex flex-col gap-6'>
            <div className='flex justify-between items-center'>
                <div className='text-xl font-medium'>
                    <div className='text-xl font-medium'>
                        {formType === "ADD" ? "Add expense categories" : "Update expense categories"}{" "}
                    </div>
                </div>
                <button type='button' className='hover:bg-hover' onClick={onClose}>
                    Cancel
                </button>
            </div>
            <div className='flex flex-col gap-4'>
                <div>
                    <ATMTextField
                        name='expenseCategoryName'
                        required
                        value={values.expenseCategoryName}
                        onChange={(e) => {
                            setFieldValue('expenseCategoryName', e.target.value);
                        }}
                        label='Expense Categories Name'
                        onBlur={handleBlur}
                    />
                </div>
            </div>
            <div>
                <ATMLoadingButton isLoading={isSubmitting} type='submit'>
                    Save
                </ATMLoadingButton>
            </div>
        </div>
    );
};

export default ExpenseCategoriesForm;